export const vendedorModais = {
  cadastroVendedor: 'cadastroVendedor',
  visualizacaoVendedor: 'visualizacaoVendedor',
};
